import { render, staticRenderFns } from "./StudentHeader.vue?vue&type=template&id=37e1837d&scoped=true&lang=pug&"
import script from "./StudentHeader.vue?vue&type=script&lang=ts&"
export * from "./StudentHeader.vue?vue&type=script&lang=ts&"
import style0 from "./StudentHeader.vue?vue&type=style&index=0&id=37e1837d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1837d",
  null
  
)

export default component.exports